// The product-profile registry.
//
// Shared code calls getProfile(slug) instead of holding product knowledge. Adding a
// configurator means adding a profile file and one line here.
import { NEUTRAL_PROFILE, type ProductProfile } from "./profile";
import { NDB_PROFILE } from "./ndb";
import { FLAME_CELLS_PROFILE } from "./flameCells";
import { FLANGE_PROFILE } from "./flange";
import { PILOT_PROFILE } from "./pilot";

export type { ProductProfile, SubmitSteps } from "./profile";
export { NEUTRAL_PROFILE } from "./profile";

const REGISTRY: Record<string, ProductProfile> = {
  [NDB_PROFILE.slug]: NDB_PROFILE,
  [FLAME_CELLS_PROFILE.slug]: FLAME_CELLS_PROFILE,
  [FLANGE_PROFILE.slug]: FLANGE_PROFILE,
  [PILOT_PROFILE.slug]: PILOT_PROFILE,
};

/**
 * The profile for a configurator slug.
 *
 * An unregistered slug gets NEUTRAL_PROFILE -- everything empty, every submit step
 * off -- rather than a default product's behaviour. A new configurator whose profile
 * has not been written yet therefore renders its own export faithfully and writes
 * nothing product-specific to NetSuite, which is the failure mode you want: visibly
 * incomplete instead of quietly behaving like Natural Draft Burners.
 */
export function getProfile(slug: string): ProductProfile {
  return REGISTRY[slug] ?? NEUTRAL_PROFILE;
}

/** Every registered slug, for tests and diagnostics. */
export function registeredProductSlugs(): string[] {
  return Object.keys(REGISTRY);
}
